module.exports = __webpack_public_path__ + "img/组 51 拷贝@2x.49d390b3.png";